import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'sc-button-2',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss']
})

export class ButtonComponent {
    @Input() disabled: boolean;
    @Input() icon: string;
    @Input() iconOnly: boolean;
    @Input() id = '';
    @Input() loading = false;
    @Input() loadingType = 'spin';
    @Input() body = '';
    @Input() size = 'medium';
    @Input() title;
    @Input() suffixIcon: string;
    @Input() type = 'btn-primary btn-siguiente';
    @Input() isFullWidth: boolean;
    @Output() onClick = new EventEmitter();
    private spin: boolean;

    constructor() {
        this.spin = this.loadingType === 'spin';
        this.isFullWidth = false;
    }

    onClickHandler(event) {
        event.stopPropagation();
        this.onClick.emit(event);
    }
}
